import {
    VIDFLEET_MAINTENANCE_WARNINGS_REQUEST,
    VIDFLEET_MAINTENANCE_WARNINGS_RESULT,
    VIDFLEET_MAINTENANCE_SET_LIST,
} from 'Redux/actionTypes';

export const maintenaceWarningRequest = (filters) => ({
    type: VIDFLEET_MAINTENANCE_WARNINGS_REQUEST,
    payload: { filters }
});

export const maintenaceWarningResult = (data) => ({
    type: VIDFLEET_MAINTENANCE_WARNINGS_RESULT,
    payload: data
});

export const maintenaceWarningSetList = (data) => ({
    type: VIDFLEET_MAINTENANCE_SET_LIST,
    payload: data
});
